
    import Vue from "vue";

    const END_POINT = "/ruleVaccination";

    const getRuleVaccination = id => Vue.axios.get(END_POINT + "/" + id);

    const getAllRuleVaccinations = data => Vue.axios.get(END_POINT, {params: data});

    const createRuleVaccination = ruleVaccination => Vue.axios.post(END_POINT,  ruleVaccination );

    const createAllRuleVaccinations = RuleVaccinations => Vue.axios.post(END_POINT + "/all",  RuleVaccinations );

    const updateRuleVaccination = ruleVaccination => Vue.axios.put(END_POINT  + "/" + ruleVaccination.id,  ruleVaccination );

    const deleteRuleVaccination = id => Vue.axios.delete(END_POINT  + "/" + id);

    export {
      getRuleVaccination,
      getAllRuleVaccinations,
      createRuleVaccination,
      createAllRuleVaccinations,
      updateRuleVaccination,
      deleteRuleVaccination
    };
    